import { gql } from '@apollo/client'
import {
  FRAGMENT_PATIENT_CHORE,
  FRAGMENT_PROFESSION_CHORE,
  FRAGMENT_REFERRAL_LIST_ITEM,
} from './fragments'

export const GET_PATIENT_REFERRALS = gql`
  query getReferrals(
    $patientId: ID!
    $paginationInput: PaginationInput
    $filterData: ReferralFilter
  ) {
    getReferrals(
      patientId: $patientId
      paginationInput: $paginationInput
      filterData: $filterData
    ) {
      total
      items {
        ...referralListItem
      }
    }
  }
  ${FRAGMENT_REFERRAL_LIST_ITEM}
`

export const GET_REFERRAL_BY_ID = gql`
  query getReferral($referralId: ID!) {
    getReferral(referralId: $referralId) {
      ...referralListItem
      patient {
        ...patientChore
        addressCity
        addressPostalCode
        addressStreet
        birthDate
      }
      logNumber
      description
      profession {
        ...professionChore
      }
      createdAtDate
      createdAtPlace
    }
  }
  ${FRAGMENT_REFERRAL_LIST_ITEM}
  ${FRAGMENT_PATIENT_CHORE}
  ${FRAGMENT_PROFESSION_CHORE}
`

export const CREATE_REFERRAL = gql`
  mutation createReferral($referralData: CreateReferralInput!) {
    createReferral(referralData: $referralData) {
      id
    }
  }
`

export const DELETE_REFERRAL = gql`
  mutation deleteReferral($referralId: String!) {
    deleteReferral(referralId: $referralId)
  }
`
